import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import { type EventAssertion, type Field } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";
import styles from "./DayInput.module.scss";

interface EventGroupDayInputProps {
    fieldData: Field<EventAssertion>;
    fieldPath: string;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const EventGroupDayInput: React.FC<EventGroupDayInputProps> = ({ fieldData, fieldPath, inputProperties }) => (
    <FieldComposer
        fieldPath={`${fieldPath}.date.day` as PrefixObjectAccessor<FormValues, []>}
        fieldConfig={fieldToConfig(fieldData)}
    >
        <FieldComposer.FieldConnector>
            {({ formField, fieldConfig, fieldPath: fieldPathFromComposer }, id) => (
                <FieldComposer.Inputs.ValueRange
                    id={id}
                    valueRange={fieldData.features.range!}
                    required={fieldConfig.required}
                    ariaLabel={inputProperties?.["aria-label"] ?? fieldData.label}
                    data-testid={fieldPathFromComposer}
                    value={formField.value ?? ""}
                    ref={formField.ref}
                    className={styles.input}
                    onChange={(e) => {
                        const val = e.target.value;
                        formField.onChange(val !== "" && Number.isFinite(Number(val)) ? Number(val) : null);
                    }}
                />
            )}
        </FieldComposer.FieldConnector>
    </FieldComposer>
);
